require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./nuit-de-la-science-0-7-3-1.json") })
        }
      }, "path---nuit-de-la-science-0-7-3-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---nuit-de-la-science-0-7-3-1!./.cache/json/nuit-de-la-science-0-7-3-1.json
// module id = 507
// module chunks = 231608221292675